import React from 'react'
import moment from 'moment'
import styled from 'styled-components'

import {
  mediaQueries,
  palette,
  fonts,
  setOpacity,
} from '../../styles/variables'
import { Text } from '../topography'
import { translate } from '../../utils/translation'
import { Desktop, Mobile } from '../../utils/media'
import Icon from '../icon/Icon'
import tipIcon1 from '../../styles/assets/seotipicons/seo_tip1.png'
import tipIcon2 from '../../styles/assets/seotipicons/seo_tip2.png'
import tipIcon3 from '../../styles/assets/seotipicons/seo_tip3.png'
import tipIcon4 from '../../styles/assets/seotipicons/seo_tip4.png'
import tipIcon5 from '../../styles/assets/seotipicons/seo_tip5.png'
import tipIcon6 from '../../styles/assets/seotipicons/seo_tip6.png'
import tipIcon7 from '../../styles/assets/seotipicons/seo_tip7.png'
import tipIcon8 from '../../styles/assets/seotipicons/seo_tip8.png'
import tipIcon9 from '../../styles/assets/seotipicons/seo_tip9.png'
import tipIcon11 from '../../styles/assets/seotipicons/seo_tip11.png'
import tipIcon12 from '../../styles/assets/seotipicons/seo_tip12.png'
import tipIcon13 from '../../styles/assets/seotipicons/seo_tip13.png'
import tipIcon14 from '../../styles/assets/seotipicons/seo_tip14.png'
import tipIcon19 from '../../styles/assets/seotipicons/seo_tip19.png'
import tipIcon20 from '../../styles/assets/seotipicons/seo_tip20.png'
import tipIcon21 from '../../styles/assets/seotipicons/seo_tip21.png'
import tipIcon24 from '../../styles/assets/seotipicons/seo_tip24.png'
import tipIcon26 from '../../styles/assets/seotipicons/seo_tip26.png'
import tipIcon29 from '../../styles/assets/seotipicons/seo_tip29.png'
import tipIcon30 from '../../styles/assets/seotipicons/seo_tip30.png'
import { LoadingWheel } from '../loading/Loading'

const SEO_TIPS = [
  {
    key: 'seo_tip1',
    icon: tipIcon1,
    color: palette.dullRed,
  },
  {
    key: 'seo_tip2',
    icon: tipIcon2,
    color: palette.brightOrange,
  },
  {
    key: 'seo_tip3',
    icon: tipIcon3,
    color: palette.warning,
  },
  {
    key: 'seo_tip4',
    icon: tipIcon4,
    color: palette.limeYellow,
  },
  {
    key: 'seo_tip5',
    icon: tipIcon5,
    color: palette.green,
  },
  {
    key: 'seo_tip6',
    icon: tipIcon6,
    color: palette.darkGreen,
  },
  {
    key: 'seo_tip7',
    icon: tipIcon7,
    color: palette.info,
  },
  {
    key: 'seo_tip8',
    icon: tipIcon8,
    color: palette.blue50,
  },
  {
    key: 'seo_tip9',
    icon: tipIcon9,
    color: palette.lightBlue,
  },
  {
    key: 'seo_tip10',
    icon: tipIcon2,
    color: palette.blue70,
  },
  {
    key: 'seo_tip11',
    icon: tipIcon11,
    color: palette.blue,
  },
  {
    key: 'seo_tip12',
    icon: tipIcon12,
    color: palette.magentaBlue,
  },
  {
    key: 'seo_tip13',
    icon: tipIcon13,
    color: palette.pink,
  },
  {
    key: 'seo_tip14',
    icon: tipIcon14,
    color: palette.darkRed,
  },
  {
    key: 'seo_tip15',
    icon: tipIcon6,
    color: palette.lightRed,
  },
  {
    key: 'seo_tip16',
    icon: tipIcon6,
    color: palette.dullRed,
  },
  {
    key: 'seo_tip17',
    icon: tipIcon3,
    color: palette.brightOrange,
  },
  {
    key: 'seo_tip18',
    icon: tipIcon6,
    color: palette.warning,
  },
  {
    key: 'seo_tip19',
    icon: tipIcon19,
    color: palette.limeYellow,
  },
  {
    key: 'seo_tip20',
    icon: tipIcon20,
    color: palette.green,
  },
  {
    key: 'seo_tip21',
    icon: tipIcon21,
    color: palette.darkGreen,
  },
  {
    key: 'seo_tip22',
    icon: tipIcon4,
    color: palette.info,
  },
  {
    key: 'seo_tip23',
    icon: tipIcon13,
    color: palette.blue50,
  },
  {
    key: 'seo_tip24',
    icon: tipIcon24,
    color: palette.lightBlue,
  },
  {
    key: 'seo_tip25',
    icon: tipIcon2,
    color: palette.blue70,
  },
  {
    key: 'seo_tip26',
    icon: tipIcon26,
    color: palette.blue,
  },
  {
    key: 'seo_tip27',
    icon: tipIcon3,
    color: palette.magentaBlue,
  },
  {
    key: 'seo_tip28',
    icon: tipIcon7,
    color: palette.pink,
  },
  {
    key: 'seo_tip29',
    icon: tipIcon29,
    color: palette.darkRed,
  },
  {
    key: 'seo_tip30',
    icon: tipIcon30,
    color: palette.lightRed,
  },
]

const SeoTipContainer = styled.div(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '85%',
  maxWidth: '746px',
  padding: '40px',
  marginBottom: '40px',
  background: palette.lightGray10,
  border: `1px solid ${palette.lightGray}`,
  [mediaQueries.mobile]: {
    flexDirection: 'column',
    padding: '24px',
    maxWidth: '420px',
  },
}))

const SeoLoader = styled.div(() => ({
  position: 'relative',
  [mediaQueries.mobile]: {
    margin: '10px 0',
  },
}))

const IconWrapper = styled.div(
  ({
    borderColor = palette.dullRed,
    bgColor = setOpacity(palette.red, 0.5),
  }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80px',
    height: '80px',
    borderRadius: '40px',
    background: bgColor,
    border: `1.5px solid ${borderColor}`,
    '& > img': {
      width: '32px',
      height: '32px',
    },
    [mediaQueries.mobile]: {
      width: '64px',
      height: '64px',
      borderRadius: '32px',
      borderWidth: '1px',
      '& > img': {
        width: '24px',
        height: '24px',
      },
    },
  }),
)

const WheelWrapper = styled.div(() => ({
  position: 'absolute',
  top: '-10px',
  left: '-10px',
}))

const TextWrapper = styled.div(() => ({
  flex: 1,
  textAlign: 'left',
  marginLeft: '24px',
  [mediaQueries.mobile]: {
    textAlign: 'center',
    marginLeft: 0,
  },
}))

const getTipByMinute = () => {
  const index = moment().minutes() % 30
  if (SEO_TIPS[index]) return SEO_TIPS[index]
  return SEO_TIPS[0]
}

export default () => {
  const tip = getTipByMinute()
  return (
    <SeoTipContainer>
      <SeoLoader>
        <IconWrapper
          borderColor={tip.color}
          bgColor={setOpacity(tip.color, 0.5)}
        >
          {tip.icon && <Icon src={tip.icon} margin="0" />}
        </IconWrapper>
        <WheelWrapper>
          <Desktop>
            <LoadingWheel width={100} height={100} />
          </Desktop>
          <Mobile>
            <LoadingWheel width={84} height={84} />
          </Mobile>
        </WheelWrapper>
      </SeoLoader>

      <TextWrapper>
        <Text
          fontFamily={fonts.primaryMedium}
          fontSize="24px"
          mobileFontSize="16px"
          lineHeight="24px"
          mobileLineHeight="16px"
          color={palette.darkGray}
          textAlign="left"
          mobileTextAlign="center"
          margin="0"
          mobileMargin="16px 0 0 0"
        >
          {translate('seo_tip_of_the_day')}
        </Text>
        <Text
          fontFamily={fonts.primary}
          fontSize="20px"
          mobileFontSize="14px"
          lineHeight="32px"
          mobileLineHeight="24px"
          color={palette.darkGray}
          textAlign="left"
          mobileTextAlign="center"
          margin="15px 0 0 0"
          moibileMargin="20px 0 0 0"
        >
          {translate(tip.key)}
        </Text>
      </TextWrapper>
    </SeoTipContainer>
  )
}
